import { DateTimeFormatter, LocalDate, ZonedDateTime, ZoneId } from "@js-joda/core";

export const formatDateToBackend = (dateStr: string): string => {
	const localDate = LocalDate.parse(dateStr);
	const zdt = ZonedDateTime.of(localDate.atStartOfDay(), ZoneId.of("UTC"));
	return zdt.toString();
};

export const formatDateFromBackend = (isoZonedDateTime: string): string => {
	const zdt = ZonedDateTime.parse(isoZonedDateTime);
	return zdt.withZoneSameInstant(ZoneId.systemDefault()).toLocalDate().toString();
};

export const formatDateTimeHumanReadable = (isoZonedDateTime: string): string => {
	const zdt = ZonedDateTime.parse(isoZonedDateTime);
	const formatter = DateTimeFormatter.ofPattern("dd.MM.yyyy");
	return zdt.withZoneSameInstant(ZoneId.systemDefault()).format(formatter);
};
export const addOneDay = (dateString: string): string => {
	const localDate = LocalDate.parse(dateString);
	const updatedDate = localDate.plusDays(1);
	return updatedDate.toString();
};
